import React from 'react';
import PropTypes from 'prop-types';
import { ExtendReactlytics } from '@americanexpress/reactlytics';
import {
  useNativeMobile,
  useUpdateDocumentTitle,
} from '@americanexpress/banking-common';
import { useFeatureFlag } from '@americanexpress/one-experiments';

import { childRoutes } from '../childRoutes';
import useSegment from '../hooks/useSegment';
import useHeapAnalytics from '../hooks/useHeapAnalytics';
import { useSegmentTrackPage } from '../hooks/useSegmentTrackPage';
import customHandlerCreators from '../customHandlerCreators';
import { BCA_OUTAGE_FF, ROUTES } from '../constants';

import './index.scss';
import SupportChatScript from './SupportChatScript';
import FullStoryScript from './FullStoryScript';
import { useDatadog } from '../hooks/useDatadog';

export const BankingBusinessCheckingRoot = ({ children }) => {
  // adding custom event handlers here (or in the future other analytics stuff)
  // to differentiate our implementation from personal-savings
  // ExtendReactlytics uses deepMerge so we don't need to spread current analytics
  const extendedAnalytics = {
    handlerCreators: customHandlerCreators,
  };
  const isNative = useNativeMobile();

  const { enabled: isOutageEnabled } = useFeatureFlag({
    featureFlagName: BCA_OUTAGE_FF,
  });

  let pathname;
  if (global.BROWSER) {
    pathname = window?.location?.pathname;
  }

  const applicationName = 'American Express Credit Cards, Rewards & Banking';

  useHeapAnalytics();
  useSegment();
  useSegmentTrackPage(pathname);
  useUpdateDocumentTitle(applicationName);
  useDatadog();

  if (isOutageEnabled && !pathname.includes(ROUTES.ERROR)) {
    window.location.replace(ROUTES.ERROR);
  }

  return (
    <>
      {!isNative && <SupportChatScript />}
      <FullStoryScript />
      <ExtendReactlytics analytics={extendedAnalytics}>
        <div className="containerAncestor">{children}</div>
      </ExtendReactlytics>
    </>
  );
};

BankingBusinessCheckingRoot.childRoutes = childRoutes;

BankingBusinessCheckingRoot.propTypes = {
  children: PropTypes.node.isRequired,
};

BankingBusinessCheckingRoot.holocron = {
  name: 'banking-business-checking-root',
};

export default BankingBusinessCheckingRoot;
